import { BufferAttribute, BufferGeometry, Mesh, OrthographicCamera, ShaderMaterial } from 'three';
import type { WebGLRenderer, WebGLRenderTarget, IUniform } from 'three';
import { FULLSCREEN_VS } from '@cloudpearl/assets';

const tri = new BufferGeometry();
tri.setAttribute('position', new BufferAttribute(new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0]), 3));
tri.setAttribute('uv', new BufferAttribute(new Float32Array([0, 0, 2, 0, 0, 2]), 2));
const cam = new OrthographicCamera(-1, 1, 1, -1, 0, 1);

/** A single full-screen triangle with its own ShaderMaterial. */
export class FullscreenPass {
  readonly material: ShaderMaterial;
  private readonly mesh: Mesh;

  constructor(fragmentShader: string, uniforms: Record<string, IUniform>, defines: Record<string, string | number> = {}) {
    this.material = new ShaderMaterial({
      vertexShader: FULLSCREEN_VS,
      fragmentShader,
      uniforms,
      defines,
      depthTest: false,
      depthWrite: false,
    });
    this.mesh = new Mesh(tri, this.material);
    this.mesh.frustumCulled = false;
  }

  get uniforms(): Record<string, IUniform> {
    return this.material.uniforms;
  }

  render(renderer: WebGLRenderer, target: WebGLRenderTarget | null, layer?: number): void {
    renderer.setRenderTarget(target, layer);
    renderer.render(this.mesh, cam);
  }

  dispose(): void {
    this.material.dispose();
  }
}
